import { render, staticRenderFns } from "./comp_GoCuotas-Payment-InstructionsCardContent.vue?vue&type=template&id=65a3e808&"
import script from "./comp_GoCuotas-Payment-InstructionsCardContent.vue?vue&type=script&lang=js&"
export * from "./comp_GoCuotas-Payment-InstructionsCardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports